import React from 'react';
import SHDButton from '@ui/Button/SHDButton';
import SHDHeading from '@ui/Heading/SHDHeading';
import SHDText from '@ui/Text/SHDText';
import SHDModalContainer from '@ui/ModalContainer/SHDModalContainer';
import { Box } from 'grommet';
import { NoScoringKeyTrayProps } from '@features/Schedule/schedule.d';

const NoScoringKeyModal: React.FC<NoScoringKeyTrayProps> = ({ onClose }) => {
  return (
    <Box>
      <SHDModalContainer>
        <Box gap="xxsmall" pad={{ bottom: 'large' }}>
          <SHDHeading level="3" textAlign="start">
            This scoring link don&apos;t contain the right authorization
          </SHDHeading>

          <SHDText color="gray-900-alpha-80" style="subhead" textAlign="start">
            Please request a new scoring link to the team owner
          </SHDText>
        </Box>
        <Box gap="small">
          <SHDButton secondary label="Close" onClick={onClose} />
        </Box>
      </SHDModalContainer>
    </Box>
  );
};

export default NoScoringKeyModal;
